import request from '@/utils/request'

export function getBase() {
  return request({
    url: '/user/basedata',
    method: 'get'
  })
}

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    tips: 0,
    data
  })
}

export function fsLogin(data) {
  return request({
    url: '/user/feishulogin',
    method: 'post',
    tips: 0,
    data
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post',
    tips: 0
  })
}

export function getOssSts() {
  return request({
    url: '/user/sts',
    method: 'get'
  })
}

export function fxLogin(data) {
  return request({
    url: '/user/fxlogin',
    method: 'post',
    tips: 0,
    data
  })
}
